import { render } from "./incident_reporting.html?vue&type=template&id=463f3d1e&external"
import script from "./incident_reporting.js?vue&type=script&lang=js&external"
export * from "./incident_reporting.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__